import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Layout, Button, Spin } from 'antd';
import './LandingPage.scss';
import { useParams } from 'react-router-dom';

const LandingPage = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);    
  const { restaurantUrl } = useParams();
  const {tableNo} = useParams();

  useEffect(() => {
    // 通过 axios 从服务器获取数据
    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/getLandingPageData/:restaurantUrl/:tableNo`);
        setData(response.data);
      } catch (err) {
        setError('Failed to fetch data from server.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="loading-spinner">
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <Layout className="landing-page">
      <div className="landing-content">
        {data?.image && <img src={data.image} alt="Landing" style={{ width: '100%', maxWidth: '600px', marginBottom: '20px' }} />}
        {data?.ctaText && (
          <Button type="primary" size="large" href={data.ctaLink}>
            {data.ctaText}
          </Button>
        )}
      </div>
    </Layout>
  );
};

export default LandingPage;
